import React, { useState } from 'react';
import ReusableButton from './common/Button/Button';
import CheckIcon from '../assets/CheckIcon';
import CrossIcon from '../assets/CrossIcon';
import CrossIconDarkForm from '../assets/icon/CrossIconForm';
import { IFlightCancelReactivateRequest } from '../type/flightCancelReactivateRequest';
import operationAPI from '../api/operationApi';
import { toast } from 'react-toastify';
import { translate } from '../i18n';
import { showOrReplaceToast } from '../utils/utility';

interface FlightCancelledModalProps {
  isOpen: boolean;
  onClose: () => void;
  flight: any; // Replace `any` with proper type if available
  onSuccess?: () => void; // optional callback after successful API call
  onConfirm: (data: any) => void;
}

const FlightCancelledModal: React.FC<FlightCancelledModalProps> = ({
  isOpen,
  onClose,
  flight,
  onSuccess,
  onConfirm,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen || !flight) return null;

  const handleConfirm = async () => {
    setIsLoading(true);
    const payload: IFlightCancelReactivateRequest = {
      operationBalloonId: flight.operationBalloonId,
      operationBalloonFlightId: flight.operationBalloonFlightId,
    };
    try {
      const response = await operationAPI.reactivateFlightCancellation(payload);
      showOrReplaceToast(
        'flight',
        translate('operation.flightDetailsUpdatedSuccessfully'),
        'success',
      )
      if (onSuccess) onSuccess();
      if (onConfirm) onConfirm(payload);
      onClose();
    } catch (error) {
      console.error('Error reactivating flight:', error);
       showOrReplaceToast(
        'flight',
        translate('operation.flightDetailsUpdatedSuccessfullyNotUpdated'),
        'error',
      )
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="">
      <div className="bg-sidebar-background space-y-3 p-8 max-w-md mx-auto rounded-lg shadow-md relative ">
        <div className="mt-2">
          <h2 className="text-xl font-semibold text-textColorGray text-center p-4">
            Are you sure you want to re-activate this flight?
          </h2>
        </div>

        <p className="text-textColorGray text-center text-sm">
          Confirming will remove the cancellation and set the flight as active.
        </p>

        <div className="flex justify-center mt-2 gap-8">
          <ReusableButton
            variant="secondary"
            children="Cancel"
            icon={
              <div>
                <div className="block dark:hidden">
                  <CrossIcon />
                </div>
                <div className="hidden dark:block">
                  <CrossIconDarkForm />
                </div>
              </div>
            }
            onClick={onClose}
            isDisabled={isLoading}
            className="w-auto bg-button-cancelButtonBgColor text-text-cancelButtonTextColor"
          />
          <ReusableButton
            icon={<CheckIcon />}
            children="Confirm"
            variant="primary"
            className="w-auto bg-background-backgroundColor"
            onClick={handleConfirm}
            isDisabled={isLoading}
            isLoader={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default FlightCancelledModal;
